module.exports = __webpack_public_path__ + "static/media/sigaaslinhas.052ba283.mp4";